export default __webpack_public_path__ + "static/speaker4-5c95c06221946c7986cce4019e441817.jpg";